import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import {
  qAPPMain_TaskParameter,
  QAPPMain_TaskParameter,
} from "../../odata/appu4dm/QAppU4DM";
import { useQuery } from "@tanstack/react-query";
import { odataFetch } from "../../lib/odata-fetch";
import { APPMain_TaskParameter } from "../../odata/appu4dm/AppU4DMModel";
import { taskKeys } from "./task-keys";

type TaskParameterPayload = Omit<Payload, "taskId"> & {
  taskId?: string | null;
};

export function useTaskParameter({ parameter, taskId }: TaskParameterPayload) {
  const { data, ...query } = useQuery({
    queryKey: taskKeys.getParameter(parameter, taskId),
    queryFn: ({ meta }) =>
      fetchTaskParameter({ parameter, taskId: taskId! }, meta!.token!),
    enabled: ({ meta }) => !!meta?.token && !!taskId,
  });

  return {
    taskParameter: data?.value?.[0]?.ParameterValue,
    ...query,
  };
}

type Payload = {
  parameter: "GF_AutomaticallyEngrave" | "GF_AutomaticallyPrintPackagingLabel";
  taskId: string;
};

async function fetchTaskParameter(payload: Payload, token: string) {
  const builder = createQueryBuilderV4(
    "APPMain_TaskParameter",
    new QAPPMain_TaskParameter()
  )
    .select("ParameterValue")
    .filter(
      qAPPMain_TaskParameter.NId.eq(payload.parameter).and(
        qAPPMain_TaskParameter.Task_Id.eq(payload.taskId)
      )
    );

  return odataFetch<Pick<APPMain_TaskParameter, "ParameterValue">>({
    builder,
    token,
  });
}
